import { useEffect, useState } from "react";
import { gtmBrokenImage } from "GTMs/actions/commonActions";
import { useTheme } from "styled-components";

function techLogger(level, label, payload, device) {
  const msg = payload ? JSON.stringify(payload) : "";
  const category = label;
  const data = { level, msg, category };
  fetch(`${process.env.NEXT_PUBLIC_API_URL_CLIENT}/logging/tech-log`, {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "content-type": "application/json",
      source: device,
    },
  })
    .then((res) => res.text())
    .then(console.log);
}

function asyncImageLoader(url, pageUrl, device) {
  return new Promise((resolve, reject) => {
    const image = new Image(); // create Image DOM
    image.src = url; // 10MB image .. require 30 second to load
    image.onload = () => resolve(url); // callback to be triggered after fully loading .. 30 seconds later
    image.onerror = (event) => {
      techLogger(
        "warning",
        "broken-image",
        // @ts-ignore
        { ImageUrl: url, pageUrl: pageUrl, type: event.type },
        device
      );
      reject(new Error("could not load image"));
    };
  });
}

const useImageLoadingHook = (imageSrc, pageUrl) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [loadingError, setLoadingError] = useState<boolean>(false);
  const { device } = useTheme();
  useEffect(() => {
    asyncImageLoader(imageSrc, pageUrl, device)
      .then(() => setIsLoading(false))
      .catch((e) => {
        setLoadingError(true);
        gtmBrokenImage();
      });
  }, []);
  return { isLoading, loadingError };
};

export default useImageLoadingHook;
